// ── thresholds-write: honest write-error → message + tone (FR-SET) ──────────
// Mirrors reports-write. Maps a threshold upsert error to an honest, non-leaking
// message via the single CO_* → posture map, so the editor speaks the same
// vocabulary as the read. A denied write reads as its honest message (never a
// leak of WHY beyond "your role can't"); a closed lane states nothing changed.

import { ApiClientError } from "../../services/api-client";
import {
  honestGateFromError,
  postureForCoachingError,
  referenceFromError
} from "../../services/coaching-error-posture";

export interface WriteErrorView {
  tone: "error" | "warning";
  message: string;
}

export function describeThresholdWriteError(error: unknown): WriteErrorView | null {
  if (error == null) return null;
  if (!(error instanceof ApiClientError)) {
    return { tone: "error", message: "Couldn't save the threshold. Please try again." };
  }
  const posture = postureForCoachingError(error);
  const reference = referenceFromError(error);
  const ref = reference ? ` (reference: ${reference})` : "";

  if (posture === "permission-denied") {
    return { tone: "error", message: "Your role can't change coaching thresholds." };
  }
  if (posture === "gate-closed") {
    const gate = honestGateFromError(error);
    return { tone: "warning", message: `${gate?.reason ?? "This action is closed right now."} No change was made.` };
  }
  if (posture === "unavailable") {
    return { tone: "error", message: "Coaching settings are temporarily unavailable. Try again in a moment." };
  }
  return { tone: "error", message: `${error.message}${ref}` };
}
